import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-white rounded-xl px-6 pt-6 pb-8 flex flex-col justify-start items-center" }
const _hoisted_2 = { class: "w-full flex items-center justify-between" }
const _hoisted_3 = { class: "w-full flex items-center justify-center space-x-4 lg:space-x-20 mt-6" }
const _hoisted_4 = { class: "grid grid-cols-1 lg:grid-cols-5 grid-rows-1 pl-0" }
const _hoisted_5 = { class: "md:flex flex-col items-center space-y-4 hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-transparent w-[4.5rem]",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full w-3 h-3 bg-wrh-blue-light" }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-blue-light w-[4.5rem]",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_7 = { class: "hidden md:flex flex-col items-center space-y-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-blue-light w-[4.5rem]",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full w-3 h-3 bg-wrh-green-medium" }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-gray-light w-[4.5rem]",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_9 = { class: "hidden md:flex flex-col items-center space-y-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-gray-light w-[4.5rem]",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full w-3 h-3 bg-wrh-gray-light" }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-gray-light w-[4.5rem]",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_11 = { class: "flex flex-col items-center space-y-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-gray-light w-[4.5rem]",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full w-3 h-3 bg-wrh-gray-light" }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-gray-light w-[4.5rem]",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_13 = { class: "hidden md:flex flex-col items-center space-y-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-wrh-gray-light w-[4.5rem]",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full w-3 h-3 bg-wrh-gray-light" }),
  /*#__PURE__*/_createElementVNode("span", {
    class: "-mt-px flex-grow h-0.5 bg-transparent w-[4.5rem]",
    "aria-hidden": "true"
  })
], -1)

import { PropType } from 'vue';
import ContractIcon from './icons/ContractIcon.vue';
import DollarIcon from './icons/DollarIcon.vue';
import SelectionsIcon from './icons/SelectionsIcon.vue';
import HammerIcon from './icons/HammerIcon.vue';
import HomeIcon from './icons/HomeIcon.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  home: {
    type: Object as PropType<any>,
    required: true,
  },
},
  setup(__props) {

const props = __props


const progressTitle = 'Home Progress';
const viewLink = 'View Timeline';
const progress = '76';
const progresslabel = 'Total Completed';
const contract = 'Contract';
const finance = 'Finance';
const selection = 'Selections';
const construction = 'Construction';
const ownership = 'Ownership';

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", { class: "t-22m text-wrh-blue-dark" }, _toDisplayString(progressTitle)),
      _createVNode(_component_router_link, {
        class: "t-14r text-wrh-blue-light capitalize",
        to: `/homes/${props.home.uid}/timeline`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(viewLink))
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(ContractIcon, { class: "w-10 h-10 text-wrh-blue-light" }),
          _hoisted_6,
          _createElementVNode("span", { class: "t-18r text-wrh-blue-light" }, _toDisplayString(contract))
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(DollarIcon, { class: "w-10 h-10 text-wrh-green-medium" }),
          _hoisted_8,
          _createElementVNode("span", { class: "t-18r text-wrh-green-medium" }, _toDisplayString(finance))
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(SelectionsIcon, { class: "w-10 h-10 text-wrh-gray-light" }),
          _hoisted_10,
          _createElementVNode("span", { class: "t-18r text-wrh-gray-light" }, _toDisplayString(selection))
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createVNode(HammerIcon, { class: "w-10 h-10 text-wrh-gray-light" }),
          _hoisted_12,
          _createElementVNode("span", { class: "t-18r text-wrh-gray-light" }, _toDisplayString(construction))
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createVNode(HomeIcon, { class: "w-10 h-10 text-wrh-gray-light" }),
          _hoisted_14,
          _createElementVNode("span", { class: "t-18r text-wrh-gray-light" }, _toDisplayString(ownership))
        ])
      ]),
      _createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
        _createElementVNode("span", { class: "t-90b text-wrh-blue-dark" }, _toDisplayString(progress) + "%"),
        _createElementVNode("span", { class: "t-18m text-wrh-blue-dark capitalize" }, _toDisplayString(progresslabel))
      ])
    ])
  ]))
}
}

})